import { render } from "./Leasing.vue?vue&type=template&id=63fe93a4&scoped=true"
import script from "./Leasing.vue?vue&type=script&lang=js"
export * from "./Leasing.vue?vue&type=script&lang=js"

import "./Leasing.vue?vue&type=style&index=0&id=63fe93a4&scoped=true&lang=scss"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63fe93a4"]])

export default __exports__